import { fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const AddHealthProfessional = async (payload) => {
  const url = `${API_CONSTANTS.HEALTH_PROFESSIONAL}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAllProfessionalDetail = async (payload) => {
  const url = `${API_CONSTANTS.GET_PROFESSIONAL_DETAILS}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const UpdateHealthProfessionalById = async (payload, healthprofessionalId) => {
  const url = `${API_CONSTANTS.UPDATE_HEALTH_PROFESSIONAL_BY_ID}?healthprofessionalId=${healthprofessionalId}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const DeleteHealthProfessional = async (healthprofessionalId) => {
  const url = `${API_CONSTANTS.DELETE_HEALTH_PROFESSIONAL}?healthprofessionalId=${healthprofessionalId}`;
  return fetchLoginCall(url, API_METHODS.DELETE);
};

export const GetHealthProfessionalByID = async (healthprofessionalId) => {
  const url = `${API_CONSTANTS.GET_HEALTH_PROFESSIONAL_BY_ID}?healthprofessionalId=${healthprofessionalId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const UpdateHealthProfessionalProfile = async (payload) => {
  const url = `${API_CONSTANTS.UPDATE_HEALTH_PROFESSIONAL_PROFILE}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAllHealthProfessionalIds = async () => {
  const url = `${API_CONSTANTS.GET_ALL_HEALTH_PROFESSIONAL_ID}`;
  return fetchLoginCall(url, API_METHODS.GET);
};
